<div class="result-container" [ngClass]="cssClassName">
  <as-split direction="horizontal">
    <as-split-area [size]="25" class="result-list">
      <div class="result-list-content" [class.loading]="isLoading">
        @if (isLoading) {
          <div class="loading-overlay" data-testid="results-loading-indicator">
            <mat-spinner diameter="36"></mat-spinner>
            <span>{{ loadingResultsLabel }}</span>
          </div>
        }
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="termName">
          <td mat-cell *matCellDef="let resData">
            <pub-term-render [term]="toRes(resData).term"
            [showLang]="hasMultipleSourceLangs()"></pub-term-render>
          </td>
        </ng-container>
        <tr mat-row *matRowDef="let res; columns: ['termName'];" (click)="resultClick(res)"></tr>
      </table>
      @if (dataSource.data?.length && resultPaginator) {
        <mat-paginator [length]="resultPaginator.totalItems"
          [pageSize]="resultPaginator.pageSize"
          [pageIndex]="resultPaginator.pageIndex" [pageSizeOptions]="pageSizeOptions"
        (page)="pageChange($event)" [showFirstLastButtons]="true"></mat-paginator>
      }
      @if (hasNoResults()) {
        <div class="not-found" data-testid="no-results-message" i18n="@@defaultResultList.noResults">No results</div>
      }
      </div>
    </as-split-area>
    <as-split-area [size]="75" class="result-details">
      @if (getSessionObj().conceptId) {
        <div>
          <pub-result-view-wrapper (conceptSelected)="selectConcept($event)"></pub-result-view-wrapper>
        </div>
      }
    </as-split-area>
  </as-split>
</div>
